import { render, staticRenderFns } from "./ResidentStatusTable.vue?vue&type=template&id=b6937830&scoped=true&lang=pug"
import script from "./ResidentStatusTable.vue?vue&type=script&lang=ts"
export * from "./ResidentStatusTable.vue?vue&type=script&lang=ts"
import style0 from "./ResidentStatusTable.vue?vue&type=style&index=0&id=b6937830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6937830",
  null
  
)

export default component.exports